import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import PrintStudentResults from "./PrintStudentResults";

const PrintActionIndividual = ({
  cardPosition,
  handleCloseCard,
  classDetails,
  individualStudentResult, // This is already pre-sorted in the parent component
  toggleScoreType,
  assessmentResultsByStudent,
  student,
}) => {
  const printCardRef = useRef(null);

  return (
    <div
      ref={printCardRef}
      className="action-card"
      style={{
        position: "absolute",
        top: `${cardPosition.top}px`,
        left: `${cardPosition.left}px`,
        zIndex: 1000,
        width: "320px",
      }}
    >
      <div className="action-card-header">
        <p className="action-header">Print</p>
        <button onClick={handleCloseCard} className="close-button">
          ✕
        </button>
      </div>

      <div className="action-card-body">
        <div className="action-button-container">
          <PrintStudentResults
            individualStudentResult={individualStudentResult}
            toggleScoreType={toggleScoreType}
            assessmentResultsByStudent={assessmentResultsByStudent}
            student={student}
            classDetails={classDetails}
            detailedView={false}
            buttonName={"Simple"}
          />
          <PrintStudentResults
            individualStudentResult={individualStudentResult}
            toggleScoreType={toggleScoreType}
            assessmentResultsByStudent={assessmentResultsByStudent}
            student={student}
            classDetails={classDetails}
            detailedView={true}
            buttonName={"Detailed"}
          />
        </div>
      </div>
    </div>
  );
};

export default PrintActionIndividual;